export default __webpack_public_path__ + "static/media/polygon.075fb5b3.svg";